import { useQuery } from "@apollo/client";
import { GetCustomers, GetCustomersVariables } from "_graphql/queries/__generated__/GetCustomers";
import { getCustomers } from "_graphql/queries/customers";

const useGetCustomers = (id: string) => {
    const { data, loading, error } = useQuery<
    GetCustomers,
    GetCustomersVariables
  >(getCustomers, {
    variables: {
      filter: {
        user_id: {
          eq: id,
        },
      },
    },
  });
  return { data, loading, error };
};

export default useGetCustomers;
